module.exports = __webpack_public_path__ + "media/src/images/icon__whatsapp--dark-8d3587fc5a912630e7af3dfadfe88911.png";